/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_SmileInputs */

const fr_fancy_vast_otter_smile = /** @type {(inputs: Fancy_Vast_Otter_SmileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulation en cours...`)
};

/**

* @param {Fancy_Vast_Otter_SmileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_smile = /** @type {((inputs?: Fancy_Vast_Otter_SmileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_SmileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_smile(inputs)
});